import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
// import uuid from "react-uuid";
// import { processors } from "../../processors";

import * as d3 from "d3";

import { locateTooltip, D3PseudoSelect } from "../misc";

export interface TooltipProps {
    id: string;
    getTooltipJSX: () => JSX.Element;
    className?: string;
    style?: React.CSSProperties;
    tooltipStyle?: React.CSSProperties;
}
export const Tooltip: React.FC<TooltipProps> = ({ children, getTooltipJSX, className, id, style, tooltipStyle }) => {
    const ref = useRef<HTMLDivElement>();
    const tooltipRef = useRef<HTMLDivElement>();
    const getTooltipJSXRef = useRef<() => JSX.Element>();
    getTooltipJSXRef.current = getTooltipJSX;

    useEffect(() => {
        const element = ref.current;

        if (element) {
            const appTooltip = document.getElementById(id);
            if (appTooltip) {
                tooltipRef.current = appTooltip as HTMLDivElement;
            } else {
                tooltipRef.current = d3.select("body").append("div").attr("class", "vis-tooltip").attr("id", id).node();
            }

            for (const prop in tooltipStyle) {
                if (tooltipRef.current) tooltipRef.current.style[prop] = tooltipStyle[prop];
            }

            const tooltip = d3.select(tooltipRef.current);

            const mouseleave = (elm: Element) => {
                d3.select(elm).classed("hovered", false);
                tooltip.style("display", "none");
            };

            const mouseover = (elm: Element) => {
                const _elm = d3.select(elm);
                if (_elm.classed("hovered")) return;

                _elm.classed("hovered", true);

                tooltip
                    .transition()
                    .duration(300)
                    .styleTween("opacity", function () {
                        if (this["_current"] === null || this["_current"] === undefined) {
                            this["_current"] = 0;
                        }

                        var interpolate = d3.interpolate(this["_current"], 0.9);
                        this["_current"] = interpolate(0);
                        return function (t) {
                            return `${interpolate(t)}`;
                        };
                    });
            };

            const mousemove = () => {
                ReactDOM.render(getTooltipJSXRef.current(), tooltip.node());

                locateTooltip({
                    d3Tooltip: tooltip as unknown as D3PseudoSelect,
                    event: d3.event
                });
            };

            d3.select(element)
                .on("mousemove", function (d, i) {
                    mousemove();
                })
                .on("mouseleave", function () {
                    mouseleave(this);
                })
                .on("mouseover", function () {
                    mouseover(this);
                });
        }

        return () => {
            const tooltip = tooltipRef.current;

            // remove events
            d3.select(element).on("mousemove", null).on("mouseleave", null).on("mouseover", null);

            // remove tooltip
            if (tooltip) {
                tooltip.remove();
            }
        };
    }, [tooltipStyle, id]);
    return (
        <div ref={ref} className={className ?? ""} style={style}>
            {children}
        </div>
    );
};
